import type { RxJsonSchema } from 'rxdb';
import type { ProductDocType } from '../types/product';

export const productSchema: RxJsonSchema<ProductDocType> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: 'string', maxLength: 100 },
    sku: { type: 'string', maxLength: 50 },
    barcode: { type: 'string', maxLength: 50 },
    price: { type: 'number' },
    cost: { type: 'number', default: 0 },
    categoryId: { type: 'string', maxLength: 36 },
    unit: { type: 'string', maxLength: 20 },
    imageUrl: { type: 'string' },
    stock: { type: 'number', default: 0 },
    minStock: { type: 'number', default: 0 },
    isActive: { type: 'boolean', default: true },
    variants: { type: 'array', items: { type: 'object' }, default: [] },
    bomItems: { type: 'array', items: { type: 'object' }, default: [] },
    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    _deleted: { type: 'boolean', default: false },
  },
  required: ['id', 'name', 'price', 'unit', 'createdAt', 'updatedAt'],
  indexes: ['categoryId', 'barcode', 'sku'],
};
